import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import Reflux from 'reflux';

import tabStateStore from '../stores/tab-state-store';
import actions from '../actions';

const CLASS_NAME = 'slx-product-wizard-panel';

export default createReactClass({

	selected: false,

	propTypes: {
		id: PropTypes.string,
		title: PropTypes.string,
		subtitle: PropTypes.string,
		children: PropTypes.node,
		active: PropTypes.bool,
		onToggle: PropTypes.func,
		isFlapable: PropTypes.bool,
		slider: PropTypes.bool,
		inline: PropTypes.bool,
		topBorder: PropTypes.bool
	},

	mixins: [
		Reflux.listenTo(tabStateStore, 'onTabChange'),
		Reflux.listenTo(actions.facetsLoaded, 'onFacetsLoaded'),
		Reflux.listenTo(actions.accessoryFacetsLoaded, 'onFacetsLoaded'),
		Reflux.listenTo(actions.windowResize, 'onResize')
	],

	getPropsDefault() {
		return {
			active: false,
			isFlapable: true,
			slider: true,
			inline: false,
			topBorder: true
		};
	},

	getInitialState() {
		return {
			selected: tabStateStore.state.selected.indexOf(this.props.id) >= 0
		};
	},

	componentDidMount() {
		if (this.props.isFlapable && this.props.active && this.state.selected) {
			this.toggle(true);
		}
	},

	onClick() {
		if (!this.props.active) {
			return;
		}
		actions.toggleTab(this.props.id);
	},

	onTabChange(data) {
		const selected = data.selected.indexOf(this.props.id) >= 0;
		this.toggle(selected);
		this.setState({selected});
	},

	toggle(selected) {
		const state = typeof selected === 'undefined' ? !this.selected : selected;
		let heightContent = 0;
		if (state) {
			heightContent = this.refs.content.offsetHeight;
		}
		this.refs.wrap.style.height = `${heightContent}px`;
		this.selected = state;
		this.props.onToggle(this.selected);
	},

	onFacetsLoaded() {
		setTimeout(this.onResize, 500); //delay resizing for css transition to play out
	},

	onResize() {
		this.toggle(this.selected);
	},

	render() {
		let className = `${CLASS_NAME} ${CLASS_NAME}--${this.props.id}`;
		if (this.props.active) {
			className += ' active';
		}
		if (!this.props.slider) {
			className += ` ${CLASS_NAME}--noslide`;
		}
		if (this.props.inline) {
			className += ` ${CLASS_NAME}--inline`;
		}
		if (this.props.topBorder) {
			className += ` ${CLASS_NAME}--top-border`;
		}
		if (!this.props.isFlapable) {
			className += ` ${CLASS_NAME}--noflap`;
		} else if (this.props.active && this.state.selected) {
			className += ' visible';
		}

		const title = this.props.title
			? (<h4 ref="title">{this.props.title}</h4>)
			: '';
		const subtitle = this.props.subtitle
			? (<span className={`${CLASS_NAME}__subtitle`} ref="subtitle">{this.props.subtitle}</span>)
			: '';

		return (
			<div className={className}>
				<div
					className={`${CLASS_NAME}__tab`}
					ref="panelTab"
					onClick={this.onClick}
				>
					<div className={`${CLASS_NAME}__tab-container`} ref="tabContainer">
						{title}
						{subtitle}
					</div>
					<div className={`${CLASS_NAME}__ref`} ref="refSizer"></div>
				</div>
				<div className={`${CLASS_NAME}__wrap`} ref="wrap">
					<div className={`${CLASS_NAME}__content`} ref="content">
						{this.props.children}
					</div>
				</div>
			</div>
		);
	}
});
